export default "/images/become-host-1.jpg?5c76b6376728253cc81b5237b1926398";